import GlobalVisualProvider, {
  useGlobalProvider,
} from './GlobalVisualProvider';

export default GlobalVisualProvider;
export { useGlobalProvider };
